import httpRequest from 'httpRequest'
import {
    GiftCardDetailContract,
    GiftCardTypePOSContract,
    GiftCardHistoryContract,
    GiftCardSaleTransferProcessContract,
    GiftCardSlimContract,
    IssueGiftCardContract,
    IssueGiftCardResult,
} from 'models'
export interface GiftCardSearchRequest {
    customerID?: string
    issueNo?: string
    forceReturn?: boolean
}
const PREFIX = '/company/gift-cards'

const giftCardService = {
    getIssuedGiftCards(searchRequest?: GiftCardSearchRequest) {
        return httpRequest.get<GiftCardSlimContract[]>(PREFIX, {
            params: searchRequest,
        })
    },
    getIssuedGiftCardByCode(code: string) {
        return httpRequest.get<GiftCardDetailContract>(
            `${PREFIX}/codes/${code}`,
        )
    },
    getGiftCardDetail(giftCardId: string) {
        return httpRequest.get<GiftCardDetailContract>(
            `${PREFIX}/${giftCardId}/history`,
        )
    },
    getGiftCardPOSProducts() {
        return httpRequest.get<GiftCardTypePOSContract[]>(`${PREFIX}/products`)
    },
    transfer(form: GiftCardSaleTransferProcessContract) {
        return httpRequest.post<GiftCardHistoryContract>(
            `${PREFIX}/transfer`,
            form,
        )
    },
    getListAllIssuedGiftCards: () =>
        httpRequest.get<GiftCardSlimContract[]>(PREFIX),

    getGenerateNewGiftCardNumber: () =>
        httpRequest.get<string>(`${PREFIX}/new-card-no`),

    createIssueGiftCard: (payload: IssueGiftCardContract) =>
        httpRequest.post<IssueGiftCardResult>(`${PREFIX}`, payload),

    deleteIssueGiftCards: (giftCardIds: string[]) =>
        httpRequest.delete(`${PREFIX}`, {
            params: { giftCardIds },
        }),
}

export default giftCardService
